import { GetProductPagedResponse, GetProductByIdResponse, ProductVariant, ProductQueryParameters, PagedResult } from '../types';
import { commerceApiClient } from './axiosService';

export const getPagedProducts = async (
  searchModel: Partial<ProductQueryParameters>
): Promise<PagedResult<GetProductPagedResponse>> => {
   // Construct query parameters (snake_case for backend)
   const params = new URLSearchParams();
    const baseUrl = '/storefront/products';
    
    if (searchModel.global_search){
      params.set('global_search', searchModel.global_search);
    }

    // Basic paging parameters
    if (searchModel.current_page) {
      params.set('current_page', searchModel.current_page.toString());
    }
    
    if (searchModel.page_size) {
      params.set('page_size', searchModel.page_size.toString());
    }
    
    // Search criteria
    if (searchModel?.product_name) {
      params.set('product_name', searchModel.product_name);
    }
    
    if (searchModel?.barcode) {
      params.set('barcode', searchModel.barcode);
    }
    
    if (searchModel?.sku) {
      params.set('sku', searchModel.sku);
    }
    
    // Filter criteria
    if (searchModel?.brands && searchModel.brands.length > 0) {
      params.set('brands', searchModel.brands.join(','));
    }   
    
    if (searchModel?.category_ids && searchModel.category_ids.length > 0) {
      params.set('category_ids', searchModel.category_ids.join(','));
    }
    
    if (searchModel?.min_price !== undefined) {
      params.set('min_price', searchModel.min_price.toString());
    }
    
    if (searchModel?.max_price !== undefined) {
      params.set('max_price', searchModel.max_price.toString());
    }
    
    if (searchModel?.only_available !== undefined) {
      params.set('only_available', searchModel.only_available.toString());
    }

    if (searchModel?.only_active !== undefined) {
      params.set('only_active', searchModel.only_active.toString());
    }
    
    // Sort criteria
    if (searchModel?.sort_type !== undefined) {
      params.set('sort_type', searchModel.sort_type.toString());
    }
    
    if (searchModel?.sort_descending !== undefined) {
      params.set('sort_descending', searchModel.sort_descending.toString());
    }

    const response = await commerceApiClient.get<PagedResult<GetProductPagedResponse>>(
      `${baseUrl}?${params.toString()}`
    );
    
    return response;
};

// Helper function to get product by ID with default organisation ID
export const getProductById = async (
  productId: string
): Promise<GetProductByIdResponse | null> => {
  try {
      const response = await commerceApiClient.get<GetProductByIdResponse>(`/storefront/products/${productId}`);
      return response;
    } catch (error) {
      return null;
    }
};

export const getProductVariantsByProductId = async (
  productId: string): Promise<ProductVariant[]> => {
    try {
      const url = `/product-variants/by-product/${productId}`;
      const variants = await commerceApiClient.get<ProductVariant[]>(url);
      return variants;
    } catch (error) {
      throw error;
    }
};
